import { useGetSettingsQuery, useSetSettingsMutation } from 'API/globalSearchBar/GlobalSearchBarSettings';
import React from 'react';
import { SimpleToggleTW } from 'tailwindComponents/toggleTW/SimpleToggleTW';
import { eSearchBarColumns } from 'types/globalSearchBar/IGlobalSearchBarSettings';
import { defaultColumns } from './ColumnDefinitions';

export const SearchBarSettingsContainer: React.FC = () => {
  const { data } = useGetSettingsQuery();
  const settings = data ?? { columns: defaultColumns };
  const [changeSettings] = useSetSettingsMutation();

  const onChange = (x: eSearchBarColumns) => (value: boolean) => {
    if (value) {
      changeSettings({ ...data, columns: [...settings.columns, x] });
    } else {
      changeSettings({ ...data, columns: settings.columns.filter((t) => t !== x) });
    }
  };

  return (
    <div>
      <div data-test-id={'Jump-Settings-Columns'}>Pick the columns you wish to see</div>
      <div className={'flex flex-col gap-1'}>
        {Object.values(eSearchBarColumns).map((t) => (
          <React.Fragment key={t}>
            <SimpleToggleTW
              text={t}
              checked={!!settings.columns.find((column) => column === t)}
              onChange={onChange(t)}
            />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
